import useEventRouting from "hooks/useEventRouting";
import ROUTES from "routes";
import useLocalStorage from "utils/useLocalStorage";
import LOCAL_STORAGE_KEYS from "constants/STORAGE_KEYS";

/*
  In sign up page:
  - no token => create
  - token => update

  In Verification page
  - no token => go back to sign up
  - token => proceed.

*/

const useRegisterLinkNavigation = () => {
  const [token] = useLocalStorage(LOCAL_STORAGE_KEYS.token, null);
  const [isActive] = useLocalStorage(LOCAL_STORAGE_KEYS.isActive, null);
  const [eventCode] = useLocalStorage(LOCAL_STORAGE_KEYS.eventCode, null);

  const { navigateWithEvent, isCurrentPage } = useEventRouting();

  const loginNavigator = (forcePush = false) => {
    let route = ROUTES.registerLink.base;
    let forceRedirect = true;
    if (!eventCode) navigateWithEvent(ROUTES.base);
    let isRouteMatching = false;

    if (!token && eventCode) {
      route = ROUTES.registerLink.signup;
    }
    if (token && !isActive) {
      route = ROUTES.registerLink.verifyLink;
      forceRedirect = forcePush || false;
    }
    if (token && isActive) {
      route = ROUTES.dashboard.base;
    }
    if (isCurrentPage(route)) {
      isRouteMatching = true;
    }
    if (isRouteMatching === false && forceRedirect) navigateWithEvent(route);
    return { isRouteMatching, route };
  };

  return loginNavigator;
};

export default useRegisterLinkNavigation;
